import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type UniversityDto = {
  _id: string;
  name: string;
  slug: string;
  countryId: string;
  location?: string;
  rankingLabel?: string;
  shortDescription?: string;
  tuitionSummary?: string;
  cardImageMediaAssetId?: string;
  ctaUrl?: string;
  order?: number;
  status?: 'DRAFT' | 'PUBLISHED';
};

export type UniversityPayload = {
  name: string;
  slug: string;
  countryId: string;
  location?: string;
  rankingLabel?: string;
  shortDescription?: string;
  tuitionSummary?: string;
  cardImageMediaAssetId?: string;
  ctaUrl?: string;
  order?: number;
  status?: 'DRAFT' | 'PUBLISHED';
};

@Injectable({ providedIn: 'root' })
export class UniversitiesService {
  constructor(private readonly api: ApiService) {}

  list(countryId?: string) {
    const q = countryId ? `?countryId=${encodeURIComponent(countryId)}` : '';
    return this.api.get<ApiEnvelope<UniversityDto[]>>(`platform/universities${q}`).pipe(map((r) => r.data));
  }

  create(payload: UniversityPayload) {
    return this.api.post<ApiEnvelope<UniversityDto>>('platform/universities', payload).pipe(map((r) => r.data));
  }

  update(id: string, payload: Partial<UniversityPayload>) {
    return this.api.patch<ApiEnvelope<UniversityDto>>(`platform/universities/${id}`, payload).pipe(map((r) => r.data));
  }

  remove(id: string) {
    return this.api.delete<ApiEnvelope<{ deleted: boolean }>>(`platform/universities/${id}`).pipe(map((r) => r.data));
  }
}
